import React from 'react';
import { motion } from 'framer-motion';
import { Code, Smartphone, Globe } from 'lucide-react';

const services = [
  {
    icon: Code,
    title: 'Custom Software',
    description: 'Tailored solutions for enterprise needs with cutting-edge technology and scalable architecture.',
  },
  {
    icon: Smartphone,
    title: 'Mobile Apps',
    description: 'Native and cross-platform experiences that engage users and deliver exceptional performance.',
  },
  {
    icon: Globe,
    title: 'Web Platforms',
    description: 'Scalable, high-performance web applications built with modern frameworks and best practices.',
  },
];

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 px-6 md:px-12 relative">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-widest text-blue-500 font-mono mb-4" data-testid="services-label">
            What We Do
          </p>
          <h2 className="text-4xl md:text-5xl font-outfit font-semibold tracking-tight" data-testid="services-title">
            Our Services
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`service-card-${index}`}
              className="group bg-slate-950/70 backdrop-blur-xl border border-slate-800/50 rounded-2xl p-8 hover:bg-slate-800/50 hover:border-blue-500/20 hover:shadow-[0_0_15px_rgba(59,130,246,0.1)] transition-all duration-300"
            >
              <div className="w-14 h-14 bg-blue-600/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600/20 transition-colors duration-300">
                <service.icon className="text-blue-500" size={28} />
              </div>
              <h3 className="text-2xl md:text-3xl font-outfit font-medium mb-4" data-testid={`service-title-${index}`}>
                {service.title}
              </h3>
              <p className="text-base text-slate-400 font-inter leading-relaxed" data-testid={`service-description-${index}`}>
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;